export default __webpack_public_path__ + "static/head_lukas-b1ea450db5ed69d40d5e645cb9edeaca.jpg";